"use strict";

import BaseProxyAcquisition from "@/proxies/base-proxy-acquisition";

/**
 * @class AuthAccountRegistrationProxy
 * @description Class used for account registration
 * @author Laurence A.
 * @version 1.0
 * @since April 20, 2023
 */
export default class AuthAccountRegistrationProxy {
  /**
   * @async
   * @function changeEmail
   * @description Method used for updating registrant email
   * @param {String} registrationToken - Registration token
   * @param {String} email - new  email to set
   */
  async changeEmail(registrationToken, email) {
    const baseProxy = new BaseProxyAcquisition();
    const backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/auth/account/registration/change-email`;
    return baseProxy.postData(endpointUrl, {
      registration_token: registrationToken,
      email: email,
    });
  }

  /**
   * @async
   * @function register
   * @description Method used for account registration
   * @param {Object} payload - Registration paqyload
   * @param {String} payload.email - User email
   * @param {String=} payload.password - Account password
   * @param {String} payload.first_name - User first name
   * @param {String} payload.last_name - User last name
   * @param {String=} payload.registration_origin - Registration origin (sleek-sign, customer)
   * @param {String=} payload.phone - User phone number
   * @param {Boolean} payload.is_stay_in_touch - Stay in touch flag (allow notifications to be sent)
   * @param {Boolean} payload.is_agree_terms_condition - Terms and condition agreement flag
   * @param {Boolean} payload.trigger_new_password - Setup new password flag
   * @param {Boolean} payload.two_factor_authentication_enabled - 2fa enabled user
   */
  async register(input = {}) {
    const baseProxy = new BaseProxyAcquisition();
    const backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/auth/account/registration`;
    return baseProxy.postData(endpointUrl, input);
  }

  /**
   * @async
   * @function resendVerification
   * @description Method used for resending account verification
   * @param {String} registrationToken - Registration token
   */
  async resendVerification(registrationToken) {
    const baseProxy = new BaseProxyAcquisition();
    const backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/auth/account/resend-verification`;
    return baseProxy.postData(endpointUrl, {
      registration_token: registrationToken,
    });
  }

  /**
   * @async
   * @function verifyAccount
   * @description Method used for verifiying account
   * @param {String} verificationToken - Verification token
   */
  async verifyAccount(verificationToken) {
    const baseProxy = new BaseProxyAcquisition();
    const backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/auth/account/verification`;
    return baseProxy.postData(endpointUrl, {
      verification_token: verificationToken,
    });
  }
}
